export const EMAIL_DOCUMENT_FOR_SIGNING = gql`
    mutation EmailDocumentForSigning($input: AdobeAgreementInput) {
        emailDocumentsToUserForSigning(input: $input) {
            agreementId
        }
    }
`;

export const GENERATE_DOCUMENT_FOR_SIGNING = gql`
    mutation GenerateDocumentWidgetForSigning($input: AdobeAgreementInput) {
        displayDocumentsForSigningOnScreen(input: $input) {
            url
        }
    }
`;
